export function isAlgoliaInsightsHit(hit) {
  return hit.objectID && hit.__autocomplete_indexName && hit.__autocomplete_queryID;
}


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/isAlgoliaInsightsHit.js
// module id = 92
// module chunks = 0